import React, { useEffect, useRef } from "react";
import "./Hero.scss";
import logoImg from "../../assets/logo.png";

function Hero() {
  const title = useRef();
  const logo = useRef();
  const subtitle = useRef();

  const animateIntro = () => {
    logo.current.style.animation = "logo-appear 1s ease-in forwards";
    title.current.style.opacity = "1";
    subtitle.current.style.opacity = "1";
  };

  useEffect(() => {
    animateIntro();
  }, []);

  return (
    <section className="hero">
      <img className="logo" src={logoImg} alt="Roberto Coin logo" ref={logo} />
      <div className="hero__content">
        <h1 className="hero__content__title" ref={title}>
          THE EXPLORER <br />
          OF BEAUTY
        </h1>

        <h2 className="hero__content__subTitle" ref={subtitle}>
          ROBERTO COIN ON FINDING INSPIRATION IN THE DETAILS
        </h2>
      </div>
      <p className="hero__credit">PHOTOGRAPHY BY ALESSANDRO GRASSANI</p>
    </section>
  );
}

export default Hero;
